interface Params {
  hostUrl: string
  bookingId: string
  redirectId?: string
  locale?: string
}
export const getDealFreezePaymentUrl = ({
  hostUrl,
  bookingId,
  locale
}: Params): string => {
  const params = new URLSearchParams()
  params.append('bookingId', bookingId)
  if (locale) params.append('locale', locale)
  return `${hostUrl}/checkout?${params.toString()}`
}
